module.exports = __webpack_public_path__ + "img/bg_image_6.e5d2de53.png";